
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Où est-il utilisé?`}</em></p>
    <p>{`Ce vaccin a été approuvé pour un usage général le 24 décembre 2020 en Chine
mais, comme les autres produits développés dans ce pays, il était
`}<a parentName="p" {...{
        "href": "217811320444"
      }}>{`déjà utilisé pour protéger des populations à risque`}</a>{`.`}</p>
    <p>{`Plusieurs pays l'emploient, comme les Emirats arabes unis, Bahrein, l’Egypte et
la Hongrie, qui est ainsi le premier pays de l’Union européenne à recourir à un
produit chinois. Ce vaccin a été
`}<a parentName="p" {...{
        "href": "https://www.who.int/fr/news-room/feature-stories/detail/the-sinopharm-covid-19-vaccine-what-you-need-to-know"
      }}>{`homologué début mai par l'OMS`}</a>{`,
pour une utilisation d'urgence.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;